<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      

                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">
                                <div class="dashboard-box margin-top-0">

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">

                                            <div class="col-xl-12 col-lg-12">
                                                <div class="row">

                                                    <div class="col-xl-6 col-xs-12 col-lg-6 col-md-8">
                                                        <div class="submit-field">
                                                            <h5>Nome </h5>
                                                            <input type="text" class="with-border" placeholder="Informe o nome aqui.." v-model="form.nome">
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-4 col-xs-12 col-md-6 col-lg-4">
                                                        <div class="submit-field">
                                                            <h5>Tipo</h5>
                                                            <select class="with-border" v-model="form.tipo" style="pointer-events: none !important;">
                                                                <option value="" disabled selected hidden>Selecione..</option>
                                                                <option value="estoque-nivel">Nível de tanque(s)</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-12">
                                                        <h3 class="">
                                                            <i class="material-icons">settings</i>
                                                            Condição para envio do alerta
                                                        </h3>
                                                    </div>
                                                    <div class="col-xl-6 col-xs-12 col-md-6 col-lg-5">
                                                        <div class="submit-field">
                                                            <h5 class="hidden-xs">&nbsp;</h5>
                                                            <select class="with-border" style="pointer-events: none !important; font-weight: bold;">
                                                                <option value="">Se o nível (%) de combustível do(s) tanque(s):</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-6 col-md-6 col-xs-12 col-xl-6">
                                                        <div class="submit-field">
                                                            <h5>Tanque(s)</h5>
                                                            <select class="selectpicker" v-model="form.ids" data-live-search="true" multiple="" show-tick="true" data-allow-clear="false" data-size="5" name="ids" title="Selecione aqui..">
                                                                <option value="*">Todos</option>
                                                                <option v-for="item in estoque.itens" :value="item.cod" v-if="item.tipo == 'tanque'">{{item.empresaNome + ' - ' + item.nome}}</option>
                                                            </select>                                            
                                                        </div>
                                                    </div> 

                                                    <div class="col-xl-6 col-xs-12 col-md-6 col-lg-6">
                                                        <div class="submit-field">
                                                            <h5>&nbsp;</h5>
                                                            <select class="with-border" v-model="form.condicao" style="pointer-events: none !important; font-weight: bold;">
                                                                <option value="<=">For igual ou menor que:</option>
                                                            </select>
                                                        </div>
                                                    </div>                                                    

                                                    <div class="col-xl-2 col-xs-6 col-md-3">
                                                        <div class="submit-field">
                                                            <h5>Valor (%)</h5>
                                                            <the-mask :mask="['#','##', '###']"  type="tel" class="with-border" placeholder="0" v-model="form.valor"/>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-12 clearfix"></div>

                                                    <div class="col-xl-6 col-xs-12 col-md-6 col-lg-5">
                                                        <div class="submit-field">
                                                            <h5 class="hidden-xs">&nbsp;</h5>
                                                            <select class="with-border" style="pointer-events: none !important; font-weight: bold;">
                                                                <option value="">Então envia notificação para o(s) usuário(s):</option>
                                                            </select>
                                                        </div>
                                                    </div>


                                                    <div class="col-xl-6 col-xs-12 col-md-6 col-lg-6">
                                                        <div class="submit-field">
                                                            <h5>Usuário(s)</h5>
                                                            <select class="selectpicker" v-model="form.destinatarios" data-live-search="true" multiple="" show-tick="true" data-allow-clear="false" data-size="5" name="destinatarios" title="Selecione aqui..">
                                                                <option v-for="item in usuarios.itens" :value="item.cod">{{item.nome}}</option>
                                                            </select>   
                                                        </div>
                                                    </div>      

                                                    <div class="col-xl-12 margin-bottom-20 margin-top-20">
                                                        <button type="submit" class="button big block-mobile" v-bind:class="{'disabled': loading.submit }">
                                                            <i class="material-icons">save</i>
                                                            {{ form.cod ? 'Salvar alerta' : 'Cadastrar alerta' }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'GerenciarAlertas',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "estoque":              {
                "itens":            []
            },  
            "usuarios":              {
                "itens":            []
            },                              
            "form": {
                "tipo":             "estoque-nivel",
                "nome":             "",
                "estoqueCod":       "",
                "ids":              [],
                "destinatarios":    [],
                "condicao":         "<=",
                "valor":            ""
            }            
        }
    },
    methods: {      
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a   = "post";
            if (self.form.cod) {
                a   = "put";
            }
            axios[a]("api/alertas.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        getEstoque: function() {
            var self        = this;
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "estoque",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "group":        false,
                        "empresa":      true
                    }
                };

                axios.get("api/estoque.php", form)
                .then(response => {
                    
                    console.log("getEstoque() result", response.data);
                    self.estoque.itens  = response.data.result.itens;
                    self.$forceUpdate();
                    resolve(response.data.result);
                    setTimeout(function() {
                        $(".selectpicker[name='ids']").selectpicker()                    
                    }, 100);

                })
                .catch(error => {
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },    
        getUsuarios: function() {
            var self        = this;
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "usuarios",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "admin,prestador,gerencial"
                    }
                };

                axios.get("api/usuarios.php", form)
                .then(response => {
                    
                    console.log("getUsuarios() result", response.data);
                    self.usuarios.itens  = response.data.result.itens;
                    self.$forceUpdate();
                    resolve(response.data.result);
                    setTimeout(function() {
                        $(".selectpicker[name='destinatarios']").selectpicker()                    
                    }, 100);                    

                })
                .catch(error => {
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },                  
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/alertas.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        init: function() {
            var self = this;

            if (self.$route.name == "EditarAlertas") {
                if (!self.$route.query.c) {
                    self.$root.back();
                    return false;
                }
                self.form.cod = self.$route.query.c;
                // self.get();
                Promise.all([
                    self.get(),
                    self.getEstoque(), 
                    self.getUsuarios(), 
                ]).then(function() {
                    loading.hide();
                }).catch(function(error) {
                    loading.hide();
                });            
            } else {
                Promise.all([
                    // self.get(),
                    self.getEstoque(), 
                    self.getUsuarios(), 
                ]).then(function() {
                    loading.hide();
                }).catch(function(error) {
                    loading.hide();
                });
            }            

        }      
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.init();
            });
        } else {
            self.init();
        }  

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .dashboard-box h3 {
        border-bottom: 1px solid #ddd;
        padding-bottom: 8px;
        margin-bottom: 25px;
        color: #000;
    }

    .dashboard-box h3 i {
        color: #FF4000;
    }
</style>



// WEBPACK FOOTER //
// src/components/GerenciarAlertas.vue